import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'
import { GetIncidentsParams } from './getIncidents'
import { ClaimRequestParam } from './getClaimRequest'

// Get Secure Score control status
export const getSecureScoreControlStatus = async () => {
  return await axios.get(endpoints.getSecureScoreControlStatus)
}

export const useSecureScoreControlStatus = (enabled = true) => {
  return useQuery({
    queryKey: [ApiKey.SECURE_SCORE_CONTROL_STATUS],
    queryFn: getSecureScoreControlStatus,
    select: data => data?.data?.controls ?? [],
    enabled,
  })
}

// Raise Claim for Secure Score
export const raisedClaimSecureScore = async (data: object) => {
  return axios.put(endpoints.claimRaisedSecureScore, data)
}

export const useRaisedClaimSecureScore = () => {
  const queryClient = useQueryClient()
  return useMutation(raisedClaimSecureScore, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.SECURE_SCORE_Threat_Listing, ApiKey.list])
    },
  })
}

// Get Secure Score Threat Listing
export const getSecureScoreThreatListing = (params: GetIncidentsParams) => {
  return axios.get(endpoints.getSecureScoreThreatListing, { params })
}

export const useSecureScoreThreatListing = (params: GetIncidentsParams) => {
  return useQuery([ApiKey.SECURE_SCORE_Threat_Listing, ApiKey.list, params], () => getSecureScoreThreatListing(params))
}

// Get Secure Score Claim Request
export const getSecureScoreClaimRequest = (params: ClaimRequestParam) => {
  return axios.get(endpoints.getSecureScoreClaimRequest, { params })
}

export const useGetSecureScoreClaimRequest = (params: ClaimRequestParam) => {
  return useQuery([ApiKey.SECURE_SCORE_Threat_Listing, ApiKey.list, params], () => getSecureScoreClaimRequest(params))
}

// Re-evaluation request for Secure Score
export const reEvaluationRequestSecureScore = async (data: object) => {
  return axios.put(endpoints.secureScoreReEvaluationRequest, data)
}

export const useReEvaluationRequestSecureScore = () => {
  const queryClient = useQueryClient()
  return useMutation(reEvaluationRequestSecureScore, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.SECURE_SCORE_Threat_Listing, ApiKey.list])
    },
  })
}
